import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
interface HighlightedParagraphProps {
  text: string;
  className?: string;
}

// Matches stats a skimmer's eye catches:
//   $50M, $50M+  — dollar amounts
//   85%, 99.99%  — percentages
//   10x, 3x      — multipliers
//   300+, 10,000+ — counts with plus
//   8 days, 4 weeks, 60 seconds, 5 months, 3 years — time durations
//   "zero"        — zero-incident / zero-downtime claims
const STAT_PATTERN = /(\bzero\b|\$[\d,]+[KMB]*\+?|\d[\d,.]*(?:%\+?|x\b|\+(?=\s|$)|\s+(?:days?|weeks?|months?|years?|seconds?|minutes?|hours?|languages?|artworks?|views?|properties?|institutions?|creatives?|subscribers?|incidents?|locations?|engineers?)))/gi;
const splitWithHighlights = (text: string): (string | {
  stat: string;
  key: number;
})[] => {
  const parts: (string | {
    stat: string;
    key: number;
  })[] = [];
  let last = 0;
  let keyCounter = 0;
  const regex = new RegExp(STAT_PATTERN.source, STAT_PATTERN.flags);
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > last) {
      parts.push(text.slice(last, match.index));
    }
    parts.push({
      stat: match[0],
      key: keyCounter++
    });
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    parts.push(text.slice(last));
  }
  return parts;
};
const HighlightedParagraph = t0 => {
  const $ = _c(5);
  const {
    text,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== text) {
    const parts = splitWithHighlights(text);
    t2 = parts.map(_temp);
    $[0] = text;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const rendered = t2;
  let t3;
  if ($[2] !== className || $[3] !== rendered) {
    t3 = <p className={className}>{rendered}</p>;
    $[2] = className;
    $[3] = rendered;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export { HighlightedParagraph };
function _temp(part, i) {
  if (typeof part === "string") {
    return part;
  }
  return <mark key={`${part.key}-${i}`} data-highlight={true} className="bg-transparent font-semibold text-zinc-100 not-italic">{part.stat}</mark>;
}